module.exports = __webpack_public_path__ + "static/media/new-york-19.eaba7ba4.jpg";